































































































































































































































































































































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, Hococo, FormModes } from '@/ts/store/Constants';
import { debounce } from 'lodash';
import PropertyManagerSuggestions from '@/components/Admin/Layout/PropertyManagerSuggestions.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import MaterialTabs from '@/components/Tabs/MaterialTabs.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';

@Component({
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isEditFormVisible',
            suggestions: 'Properties/getManagerSuggestions',
        }),
    },
    components: {
        PropertyManagerSuggestions,
        DatePicker,
        MaterialTabs,
    },
})
export default class EditPropertyForm extends Mixins(InputFieldMethods, LocalizationMethods) {
    @Prop() public formMode: string;
    public searchQuery: string = '';
    public queryDebounceManager: any | null;
    public activeTab = 'private';
    public tabs: any = [
        { title: this.$t('general.private', 'Private'), value: 'private', disabled: this.isEditing },
        { title: this.$t('general.commercial', 'Commercial'), value: 'commercial', disabled: this.isEditing },
    ];

    constructor() {
        super();

        this.queryDebounceManager = debounce(() => {
            this.queryManagers();
        }, Hococo.SUGGESTION_DEBOUNCE_PERIOD);
    }

    get errorCollection() {
        return this.errors.any();
    }

    get isEditing() {
        return (this.formMode === FormModes.Edit);
    }

    get isCreating() {
        return (this.formMode === FormModes.Create);
    }

    get managerName() {
        return (userId: number) => {
            return this.$store.getters['User/getCacheUser'](userId).fullName;
        };
    }

    public removeManager(managerId: number) {
        this.$store.commit(Mutations.REMOVE_MANAGER_FROM_ACTIVE_PROPERTY, managerId);
    }

    get activeProperty() {
        if (this.$store.state.Properties.activePropertyId === null) {
            return null;
        }

        const property = this.$store.state.Properties.properties[
            this.$store.state.Properties.propertiesMap[
                this.$store.state.Properties.activePropertyId
                ]
            ];

        this.activeTab = property.isCommercial ? 'commercial' : 'private';
        this.$store.commit(Mutations.UPDATE_PROPERTY_COMMERCIAL_TYPE, this.activeTab === 'commercial');

        return property;
    }

    get suggestionsVisible() {
        return this.$store.getters['Properties/userSuggestionsVisible'];
    }

    get getPropertiesData(): any {
        return this.$store.getters['Properties/allProperties'];
    }

    get getVariantsData(): any {
        return this.$store.getters['Variants/allVariantsForCurrentSelection'];
    }

    get getCountriesData(): any {
        return this.$store.getters['Properties/allCountries'];
    }

    get getBuildingsData(): any {
        return this.$store.getters['Buildings/allBuildings'];
    }

    get menuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get menuClass() {
        return {
            activeForm: this.menuVisible,
        };
    }

    get variantId(): number {
        return this.$store.getters['Properties/getPropertyVariant'];
    }

    set variantId(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_VARIANT_ID, value);
        return;
    }

    get countryId(): number {
        return this.$store.getters['Properties/getPropertyCountry'];
    }

    set countryId(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_COUNTRY_ID, value);
        return;
    }

    get buildingId(): number {
        return this.$store.getters['Properties/getPropertyBuilding'];
    }

    set buildingId(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_BUILDING_ID, value);
        return;
    }

    get titleNumber(): string {
        return this.$store.getters['Properties/getPropertyTitleNumber'];
    }

    set titleNumber(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_TITLE_NUMBER, value);
        return;
    }

    get propertyManager(): string {
        return this.$store.getters['Properties/getPropertyManager'];
    }

    set propertyManager(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_MANAGER, value);
        return;
    }

    get propertyAddress(): string {
        return this.$store.getters['Properties/getPropertyAddress'];
    }

    set propertyAddress(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_ADDRESS, value);
        return;
    }

    get propertyCity(): string {
        return this.$store.getters['Properties/getPropertyCity'];
    }

    set propertyCity(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_CITY, value);
        return;
    }

    get propertyZipCode(): number {
        return this.$store.getters['Properties/getPropertyZipCode'];
    }

    set propertyZipCode(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_ZIP_CODE, value);
        return;
    }

    get propertyFloor(): number {
        return this.$store.getters['Properties/getPropertyFloor'];
    }

    set propertyFloor(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_FLOOR, value);
        return;
    }

    get rent(): number {
        return this.$store.getters['Properties/getRent'];
    }

    set rent(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_RENT, value);
        return;
    }

    get water(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.waterCost;
    }

    set water(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_WATER_COST, value);
        return;
    }

    get heating(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.heatingCost;
    }

    set heating(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_HEATING_COST, value);
        return;
    }

    get area(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.area;
    }

    set area(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_AREA, value);
        return;
    }

    get rooms(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.rooms;
    }

    set rooms(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_ROOMS, value);
        return;
    }

    get power(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.electricityCost;
    }

    set power(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_POWER_COST, value);
        return;
    }

    get internet(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.internetCost;
    }

    set internet(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_INTERNET_COST, value);
        return;
    }

    get prepaidRent(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.prepaidRent;
    }

    set prepaidRent(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_PREPAID_RENT, value);
        return;
    }

    get futureRent(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.futureRent;
    }

    set futureRent(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_FUTURE_RENT, value);
        return;
    }

    get totalPaid(): number {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.ubTotal;
    }

    set totalPaid(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_TOTAL_PAID, value);
        return;
    }

    get unitTypeUb(): string {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.unitType;
    }

    set unitTypeUb(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_UNIT_TYPE_UB, value);
        return;
    }

    get vacantFromDate(): string {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.vacantFrom;
    }

    set vacantFromDate(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_VACANT_FROM_DATE, value);
        return;
    }

    get releaseDate(): string {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.releaseDate;
    }

    set releaseDate(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_RELEASE_DATE, value);
        return;
    }

    get movingInDate(): string {
        if (this.activeProperty === null) {
            return null;
        }

        return this.activeProperty.moveInDate;
    }

    set movingInDate(value: string) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_MOVING_IN_DATE, value);
        return;
    }

    get deposit(): number {
        return this.$store.getters['Properties/getDeposit'];
    }

    set deposit(value: number) {
        this.$store.commit(Mutations.UPDATE_PROPERTY_DEPOSIT, value);
        return;
    }

    public changeActiveTab(tab: string) {
        this.errors.clear();
        this.activeTab = tab;

        this.$store.commit(Mutations.UPDATE_PROPERTY_COMMERCIAL_TYPE, this.activeTab === 'commercial');
    }

    public dataLoaded(): boolean {
        return (this.getPropertiesData);
    }

    public queryManagers(): void {
        this.$store.dispatch(Actions.QUERY_PROPERTY_MANAGER_SUGGESTIONS);
        this.$store.commit(Mutations.SHOW_PROPERTY_USER_SUGGESTIONS);
    }

    public create() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.HIDE_FORM);
                this.$store.dispatch(Actions.POST_PROPERTIES);
            }
        });
    }

    public cancel() {
        if (this.isEditing) {
            this.$store.commit(Mutations.HIDE_EDIT_PROPERTY_FORM);
            this.$store.commit(Mutations.CANCEL_EDIT_PROPERTY);
        } else {
            this.$store.dispatch(Actions.HIDE_FORM);

            this.variantId = null;
            this.countryId = null;
            this.buildingId = null;
            this.titleNumber = '';
            this.propertyManager = '';
            this.propertyAddress = '';
            this.propertyCity = '';
            this.propertyZipCode = null;
            this.propertyFloor = null;
            this.rent = null;
            this.deposit = null;

            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });
        }
    }

    public edit() {
        const fromLandingPage = this.$router.currentRoute.name === 'admin-unit-details';
        const unitId = this.$router.currentRoute.params.unitId;

        this.$store.commit(Mutations.HIDE_EDIT_PROPERTY_FORM);
        this.$store.dispatch(Actions.EDIT_PROPERTY, {fromLandingPage, unitId});
    }

    get managerSearchQuery(): string {
        return this.$store.state.Properties.managerSearchQuery;
    }

    set managerSearchQuery(value: string) {
        this.$store.commit(Mutations.SET_PROPERTY_MANAGER_SEARCH_QUERY, value);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_VARIANTS);
        this.$store.dispatch(Actions.FETCH_COUNTRIES);
        this.$store.dispatch(Actions.FETCH_BUILDINGS);
    }
}
